import { read } from 'fs';
import './readmore.scss';

export default (context: HTMLElement | Document = document) => {
  const containers: NodeListOf<HTMLElement> = context.querySelectorAll('.readmore-container');
  for (let container of containers) {
    const childElm: HTMLElement = container.querySelector('.readmore-overflown');
    const readmoreBtn = container.querySelector('.js-toggle-readmore');

    if (!readmoreBtn) return;
    readmoreBtn.addEventListener('click', (e) => {
      e.preventDefault();
      toggleState((e.target as HTMLElement).closest('a'), childElm);
      readmoreBtn.classList.toggle('more');
    });
    if (checkIfOverflown(childElm)) {
      if (childElm) {
        if (childElm.offsetHeight <= container.offsetHeight) {
          readmoreBtn.classList.add('d-none');
        } else {
          readmoreBtn.classList.remove('d-none');
        }
      }

      if (container.offsetHeight >= parseInt(container.getAttribute('data-max-height'))) {
        container.classList.add('overflown', 'stop-max-height');
        readmoreBtn.setAttribute('style', 'display: unset !important');
        readmoreBtn.classList.remove('d-none');
        childElm.classList.remove('no-overflow');
      } else {
        container.classList.remove('overflown', 'stop-max-height');
        childElm.classList.add('no-overflow');
      }
    }
  }
};

export const toggleState = (toggleBtn, readmoreText) => {
  const stateText =
    toggleBtn.innerText === toggleBtn.getAttribute('data-readless')
      ? toggleBtn.getAttribute('data-readmore')
      : toggleBtn.getAttribute('data-readless');
  readmoreText.classList.toggle('readmore-overflown');
  toggleBtn.innerHTML = stateText;
};

export const checkIfOverflown = (childElm: HTMLElement) => {
  let overflownHeight = childElm.offsetHeight;
  let fullHeight = (childElm.firstElementChild as HTMLElement).offsetHeight;
  let readMoreLink = childElm.parentElement.querySelector('.js-toggle-readmore');
  if (fullHeight === overflownHeight && readMoreLink && readMoreLink.closest('tab-pane') !== null) {
    readMoreLink.classList.add('d-none');
    return false;
  } else {
    return true;
  }
};
